import { productCompareFlyOutStyles } from "@insite/content-library/Components/ProductCompareFlyOut";
import { clearBtnStyle, removeBtnFocusBorder } from "@waytek/Utilities/styleguide/btnIcon";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

productCompareFlyOutStyles.headerGridContainer = {
    ...productCompareFlyOutStyles.headerGridContainer,

    gap: 10,
};

productCompareFlyOutStyles.headerTitleGridItem = {
    ...productCompareFlyOutStyles.headerTitleGridItem,

    css: css`
        padding-left: 10px;
    `,
};

productCompareFlyOutStyles.carousel = {
    ...productCompareFlyOutStyles.carousel,

    prevArrowButton: {
        css: css`
            ${clearBtnStyle}
            ${removeBtnFocusBorder}
        `,
    },

    nextArrowButton: {
        css: css`
            ${clearBtnStyle}
            ${removeBtnFocusBorder}
        `,
    },
};

productCompareFlyOutStyles.carouselDrawer = {
    ...productCompareFlyOutStyles.carouselDrawer,

    cssOverrides: {
        ...productCompareFlyOutStyles.carouselDrawer?.cssOverrides,

        scrim: css`
            ${productCompareFlyOutStyles.carouselDrawer?.cssOverrides?.scrim}

            ${mediaQueriesBP.maxMD} {
                height: auto;
                max-height: 125px;
            }
        `,
        drawerBody: css`
            ${productCompareFlyOutStyles.carouselDrawer?.cssOverrides?.drawerBody}

            ${mediaQueriesBP.maxMD} {
                height: auto;
                max-height: 125px;
            }
        `,
    },
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    ...productCompareFlyOutStyles.removeProductFromCompareButton,

    css: css`
        ${clearBtnStyle}
        ${removeBtnFocusBorder}
    `,
};
